var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "../../../../../interface/IVueDialog";
import ActivityPreview from "../ActivityPreview.vue";
import Addgood from "../addGoodsCol2/AddGoods.vue";
import ShoppingManageService from '../../../../../api/ShoppingManageService';
var AddCategroy = (function (_super) {
    __extends(AddCategroy, _super);
    function AddCategroy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goodsList = [];
        return _this;
    }
    AddCategroy.prototype.created = function () {
        this.service = ShoppingManageService.getInstance();
    };
    AddCategroy.prototype.previewDate = function (data) {
        this.goodsList = data ? data : [];
    };
    AddCategroy.prototype.closeData = function (data) {
        this.$emit('saveAndClose', data);
    };
    AddCategroy.prototype.closeDiolog = function (status) {
        this.$emit('closeDio', status);
    };
    __decorate([
        Prop({
            type: Object
        })
    ], AddCategroy.prototype, "imageItem", void 0);
    __decorate([
        Prop({
            default: "",
            type: String
        })
    ], AddCategroy.prototype, "typeName", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], AddCategroy.prototype, "dialogVisible", void 0);
    AddCategroy = __decorate([
        Component({
            components: {
                'activity-preview': ActivityPreview,
                'add-good': Addgood
            }
        })
    ], AddCategroy);
    return AddCategroy;
}(VueDialog));
export default AddCategroy;
